module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main-box-vc"
  }, [_c('div', {
    staticClass: "table-cell home-wrap"
  }, [_c('div', {
    staticClass: "main-box"
  }, [_c('div', {
    staticClass: "main-box-content"
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_c('center', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/aboutbricks.png",
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-danger",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("GET STARTED")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticStyle: {
      "color": "#00274c",
      "font-family": "'LibreFranklinRegular'"
    }
  }, [_c('b', [_vm._v("TITAN PROMENADE TRIBUTE PROGRAM")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f35480e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = BNIV
// module chunks = 1